import { useIntl } from '@capsicum/common';
import { ExternalLinkIcon } from '@capsicum/common-web/icons';
import styled from 'styled-components';

export const LinkField = ({ href }: { href: string }) => {
	const { $t } = useIntl();

	return (
		<S.LinkText href={href} rel="noreferrer" target="_blank">
			{$t('wallet.transactionHistory.details.viewExplorer')}
			<ExternalLinkIcon />
		</S.LinkText>
	);
};

namespace S {
	export const LinkText = styled.a`
		${({ theme }) => theme.fonts.text.text1};
		display: flex;
		align-items: center;
		gap: ${({ theme }) => theme.spacings.xxsmall};
	`;
}
